// extracted by mini-css-extract-plugin
export default {"About":"About_About__LeFbV","shad":"About_shad__ToIjt"};